<template>
  <div class="searchEngine" @click.prevent.stop="emptyMethod">
    <vue-autosuggest
      ref="autosuggest"
      :suggestions="filteredSuggestions"
      :input-props="{id:'autosuggest__input', onInputChange: fetchResults, placeholder: placeholder}"
      :getSuggestionValue="getSuggestionValue"
      @selected="selectHandler"
      @click="clickHandler"
      >  
      <template slot-scope="{ suggestion }">
        <span class="my-suggestion-item">{{ suggestion.item.label }}</span>
      </template>
    </vue-autosuggest>
  </div>
</template>

<script>
export default {
  name: "searchEngine",
  props: {
    msg: String,
    suggestionsUrl: String,
    placeholder: String,
    elementsMax: {
      type: Number,
      default: 10
    }
  },
  data: () => {
    return {
      suggestions: [],
      filteredSuggestions: []
    };
  },
  methods: {
    emptyMethod() {},
    async fetchResults(text) {
      let elementsSelected = 0;
      this.filteredSuggestions = [
        {
          data: this.suggestions.filter(item => {
            if (
              text &&
              item.label.toLowerCase().indexOf(text.toLowerCase()) === 0 &&
              elementsSelected < this.elementsMax
            ) {
              elementsSelected++;
              return true;
            }
          })
        }
      ];
      await this.$nextTick();
      this.$refs.autosuggest.setCurrentIndex(0);
      if (!text) {
        this.$emit("clear");
        return;
      }
      if (this.filteredSuggestions[0].data.length === 0) {
        this.$emit("nothing");
        return;
      }
    },
    selectHandler(datas) {
      this.$emit("found", datas.item);
    },
    clickHandler(datas) {
      if (datas && datas.item && datas.item.label) {
        this.fetchResults(datas.item.label);
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.label;
    }
  },
  mounted() {
    window.document.addEventListener("click", () => {
      this.filteredSuggestions = [{ data: [] }];
    });
    this.$axios
      .get(this.suggestionsUrl)
      .then(({ data }) => {
        this.suggestions = [];
        for (let key in data) {
          this.suggestions.push({ label: key, file: data[key] });
        }
      })
      .catch(error => {
        console.error(error);
        this.$emit("error", "No file found");
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.searchEngine {
  font-family: Arial, Helvetica, sans-serif;
  width: 300px;
  position: relative;
  font-size: 14px;

  & + p {
    margin-top: 1em;
    margin-bottom: 1em;
    font-size: 14px;
    & > a {
      font-size: 16px;
    }
  }

  input {
    color: black;
    font-size: 14px;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    border-color: #666;
    width: 100%;
    &::placeholder {
      color: #999;
    }
  }
  .autosuggest__results {
    z-index: 1;
    background-color: white;
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    border-left: 1px solid #999;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
  }
  ul {
    padding: 0;
    margin: 0;
  }
  ul:not(:hover) {
    .autosuggest__results_item-highlighted {
      background: rgba(#000000, 0.05);
    }
  }
  li {
    padding: 10px;
    transition: background 0.1s linear;
    &:hover {
      cursor: pointer;
      background: rgba(#000000, 0.05);
    }
  }
}
</style>
